import { StepperStepBody } from './StepperStepBody'
import { useStepperStepContext } from './StepperStepContext'
import { UploadFilesActionPanel } from '../../shared/UploadFilesActionPanel'

export function StepUploadFiles() {
  const { action, contentClassName, step, stepData } = useStepperStepContext()
  const uploadAction = action.type === 'uploadfiles' ? action : null
  if (!uploadAction) return null

  const namespaceParam = uploadAction?.parameter_mappings?.namespace
  const mappedNamespace = namespaceParam ? (stepData as Record<string, unknown>)[namespaceParam] : undefined
  const uploadNamespace = typeof mappedNamespace === 'string' ? mappedNamespace.trim() : ''

  return (
    <UploadFilesActionPanel
      action={uploadAction}
      title={step.title}
      uploadNamespace={uploadNamespace}
      permissions={uploadAction.permissions}
      showTitle={false}
      showLandingFiles={Boolean(namespaceParam)}
      namespaceMappingPresent={Boolean(namespaceParam)}
      trigger={(onOpen) => (
        <button type="button" className={contentClassName} onClick={onOpen}>
          <StepperStepBody />
        </button>
      )}
    />
  )
}

export { LandingFileItem, LandingFilesList } from '../../shared/UploadFilesActionPanel'
